import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import rehypeRaw from "rehype-raw";

const MdH1 = (p) => <h2 className="font-display font-black italic uppercase text-3xl mt-8 mb-3" {...p} />;
const MdH2 = (p) => <h3 className="font-display font-black italic uppercase text-2xl mt-7 mb-2" {...p} />;
const MdH3 = (p) => <h4 className="font-display font-black italic uppercase text-xl mt-6 mb-2" {...p} />;
const MdP  = (p) => <p className="text-sm text-neutral-300 leading-relaxed my-3" {...p} />;
const MdUl = (p) => <ul className="list-disc list-outside pl-5 my-3 space-y-1 text-sm text-neutral-300" {...p} />;
const MdOl = (p) => <ol className="list-decimal list-outside pl-5 my-3 space-y-1 text-sm text-neutral-300" {...p} />;
const MdLi = (p) => <li className="leading-relaxed" {...p} />;
const MdA  = ({ href, ...p }) => (
  <a
    href={href}
    target={href && href.startsWith("http") ? "_blank" : undefined}
    rel={href && href.startsWith("http") ? "noreferrer" : undefined}
    className="text-[#00E5FF] underline-offset-4 hover:underline"
    {...p}
  />
);
const MdStrong = (p) => <strong className="text-white font-bold" {...p} />;
const MdEm = (p) => <em className="italic text-neutral-200" {...p} />;
const MdHr = () => <hr className="border-white/10 my-8" />;
const MdBlockquote = (p) => <blockquote className="border-l-2 border-[#00E5FF] pl-4 my-4 text-neutral-400 italic" {...p} />;
const MdCode = ({ inline, children, ...p }) =>
  inline ? (
    <code className="bg-white/10 px-1.5 py-0.5 text-[12px] font-mono text-cyan-200 rounded-sm" {...p}>{children}</code>
  ) : (
    <pre className="bg-[#0B0F19] border border-white/10 p-3 overflow-x-auto my-3">
      <code className="text-xs font-mono text-neutral-200" {...p}>{children}</code>
    </pre>
  );
const MdTable = (p) => (
  <div className="overflow-x-auto my-4">
    <table className="text-sm border-collapse w-full" {...p} />
  </div>
);
const MdTh = (p) => <th className="border-b border-white/20 text-left px-3 py-2 font-bold uppercase tracking-widest text-xs" {...p} />;
const MdTd = (p) => <td className="border-b border-white/10 px-3 py-2 align-top" {...p} />;
const MdImg = ({ alt, ...p }) => (
  <img alt={alt || ""} loading="lazy" className="w-full h-auto my-4 border border-white/10" {...p} />
);

const MD_COMPONENTS = {
  h1: MdH1, h2: MdH2, h3: MdH3,
  p: MdP, ul: MdUl, ol: MdOl, li: MdLi,
  a: MdA, strong: MdStrong, em: MdEm,
  hr: MdHr, blockquote: MdBlockquote,
  code: MdCode,
  table: MdTable, th: MdTh, td: MdTd,
  img: MdImg,
};

const REMARK_PLUGINS = [remarkGfm, remarkBreaks];
const REHYPE_PLUGINS = [rehypeRaw];

/**
 * Wiederverwendbarer Markdown-Renderer mit Sector-Four-Styling.
 * Unterstützt GitHub-Flavored Markdown (Tabellen, Strikethrough, Auto-Links)
 * sowie eingebettetes HTML (z. B. fertig generierte Datenschutz-Erklärungen).
 */
export default function Markdown({ children, className = "" }) {
  if (!children) return null;
  return (
    <div className={`md-content ${className}`}>
      <ReactMarkdown
        remarkPlugins={REMARK_PLUGINS}
        rehypePlugins={REHYPE_PLUGINS}
        components={MD_COMPONENTS}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
